import React, { Component, createRef } from 'react'
import PropTypes from 'prop-types'
import ReactToPrint from 'react-to-print'
import PasswordPrinter from '@app/components/shared/PasswordPrinter'
import ActionButton from '@app/components/ui/buttons/ActionButton'
import _ from 'lodash'

class PasswordsPrintButton extends Component {
  constructor(props) {
    super(props)
    this.printingComponent = createRef();
    this.trigger = createRef();
  }

  get printer() { return this.trigger.current }

  render() {
    let { children, students, ...rest } = this.props
    let objects = _.map(students, 'object')

    return (
      <React.Fragment>
        <PasswordPrinter ref={this.printingComponent} students={objects} />
        <ReactToPrint
          ref={this.trigger}
          trigger={
            () => (
              <ActionButton {...rest}>
                { children }
              </ActionButton>
            )
          }
          content={() => this.printingComponent.current }
          bodyClass="print"
        />
      </React.Fragment>
    )
  }
}

PasswordsPrintButton.propTypes = {
  students: PropTypes.array.isRequired
}

export default PasswordsPrintButton
